import {
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "./EbsSshDetails.module.scss";
import { EBS_SFTP } from "../../../../../../../Utils/roconConstants";

/**
 * SFTP of an EBS (v2) site on Dev Tools: one login (the site name) through the site's own port
 * on the shared NLB, with the SSH password chosen at creation. No password is ever shown.
 */
export default function EbsSftpDetails({ sftp }) {
  const available = sftp?.available === true;

  return (
    <Grid2>
      <TableContainer className={styles.main}>
        <Grid2 className={styles.display}>
          <Grid2 className={styles.header1}>{EBS_SFTP.TITLE}</Grid2>
        </Grid2>

        {!sftp ? null : available ? (
          <>
            <Table>
              <TableHead className={styles.tableHead}>
                <TableRow className={styles.tablerow}>
                  <TableCell className={styles.tableHeaderText}>Host</TableCell>
                  <TableCell className={styles.tableHeaderText}>
                    User Name
                  </TableCell>
                  <TableCell className={styles.tableHeaderText}>Port</TableCell>
                  <TableCell className={styles.tableHeaderText}>
                    Protocol
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow className={styles.row}>
                  <TableCell className={styles.tableBodyText}>
                    {sftp.host}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {sftp.username}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>
                    {sftp.port}
                  </TableCell>
                  <TableCell className={styles.tableBodyText}>SFTP</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Grid2 className={styles.steps}>
              <Grid2 className={styles.stepsTitle}>{EBS_SFTP.STEPS_TITLE}</Grid2>
              <ol className={styles.stepList}>
                {EBS_SFTP.STEPS.map((step, index) => (
                  <li key={index} className={styles.step}>
                    {step}
                  </li>
                ))}
              </ol>
            </Grid2>
            <Grid2 className={styles.note}>{EBS_SFTP.PASSWORD_NOTE}</Grid2>
          </>
        ) : (
          <Grid2 className={styles.noData}>{EBS_SFTP.NOT_AVAILABLE}</Grid2>
        )}
      </TableContainer>
    </Grid2>
  );
}
